import { ListItemIcon, Menu, MenuItem, MenuList } from "@mui/material";
import React from "react";
import { FaRegImage } from "react-icons/fa";
import { GiVendingMachine } from "react-icons/gi";

const GlobalOfferMenu = ({ offer, anchorEl, handleClose, setMachineOpen ,setImageOpen}) => {
  return (
    <Menu
      anchorEl={anchorEl}
      open={anchorEl !== null}
      onClose={handleClose}
      onClick={handleClose}
      transformOrigin={{ horizontal: "right", vertical: "top" }}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
    >
      <MenuList dense={false}>
        {offer.offer_scope === "sel" && (
          <MenuItem
            onClick={() => {
              setMachineOpen(true);
            }}
          >
            <ListItemIcon sx={{ color: "black" }}>
              <GiVendingMachine />
            </ListItemIcon>
            View machines
          </MenuItem>
        )}
        <MenuItem
          onClick={() => {
            setImageOpen(true);
          }}
        >
          <ListItemIcon sx={{ color: "black" }}>
            <FaRegImage />
          </ListItemIcon>
          Offer image
        </MenuItem>
      </MenuList>
    </Menu>
  );
};

export default GlobalOfferMenu;
